import * as React from 'react';
import { SyntheticEvent } from 'react';
import DocumentTitle from 'react-document-title';

const qs = require('query-string');
window['UPLOADCARE_PUBLIC_KEY'] = process.env['REACT_APP_UPLOADCARE_PUBLIC_KEY'];

import { commit } from './commit';

const displayModal = (id: string, display: string) => ($(`#${id}`) as any).modal(display);
export const showModal = (id: string) => displayModal(id, 'show');
(global as any).showModal = showModal;
export const hideModal = (id: string) => displayModal(id, 'hide');
export const switchModal = (id1: string, id2: string) => {
    displayModal(id1, 'hide');
    displayModal(id2, 'show');
};

export const onHidden = (id: string, f: () => void) => $(`#${id}`).on(
    'hidden.bs.modal',
    f
);
export const onShow = (id: string, f: () => void) => $(`#${id}`).on(
    'show.bs.modal',
    f
);

export const modal = (id: string, titleModal: string, body: object, footer?: object | boolean) => (
    <div
        key={id}
        className="modal fade"
        id={id}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
    >
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">{titleModal}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {body}
                </div>
                <div className="modal-footer">
                    {footer === true ? (
                        <button
                            type="button"
                            className="btn btn-default btn-fixed"
                            onClick={() => hideModal(id)}
                        >
                            Ok
                        </button>
                    ) : footer}
                </div>
            </div>
        </div>
    </div>
);

export const modalLarge = (id: string, titleModal: string, body: object, footer?: object) => (
    <div
        key={id}
        className="modal fade"
        id={id}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
    >
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">{titleModal}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {body}
                </div>
                <div className="modal-footer">
                    {footer}
                </div>
            </div>
        </div>
    </div>
);

export const modalSuperLarge = (id: string, titleModal: string, body: object, footer?: object, hideable?: boolean) => (
    <div
        className="modal fade"
        id={id}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop={hideable ? undefined : 'static'}
    >
        <div className="modal-dialog modal-lg" role="document" style={{maxWidth: '1000px'}}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">{titleModal}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {body}
                </div>
                <div className="modal-footer">
                    {footer}
                </div>
            </div>
        </div>
    </div>
);

export const bold = (body: object | string) => <span style={{fontWeight: 'bold'}}>{body}</span>;

export function customValidity(k: string, msg: string) {
    (document.getElementById(k) as any).setCustomValidity(msg);
}

interface Submittable {
    submit(): void;
}

export function submit(submittable: Submittable) {
    return (e: SyntheticEvent<any>) => { e.preventDefault(); submittable.submit(); };
}

export const identity = (x: any) => x;

export const or = (a: any, b: any) => a || a === 0 ? a : b;

export const objMap = (f: (x: any) => any, m: object) => {
    const kvs = [];
    for (let k in m) {
        if (m.hasOwnProperty(k)) {
            kvs.push([k, m[k]]);
        }
    }
    return kvs.map(f);
};

export const trueMap = (x: object) => {
    for (let i in x) {
        if (x.hasOwnProperty(i) && x[i]) {
            return true;
        }
    }
    return false;
};

export function butlast<A>(as: A[]) {
    return as.slice(0, as.length - 1);
}

export function setToFunction<A>(s: Set<A>) {
    return (a: A) => s.has(a) ? a : undefined;
}

export const backend = process.env['REACT_APP_CORS_HOST'];
export const host = process.env['REACT_APP_HOST'];
export const CI = process.env['CI'] === 'true';
const env = process.env['REACT_APP_ENV'];
export const isProd = env === 'prod';
export const isStg = env === 'stg';
export const isDev = env === 'dev';

if (isStg || isProd) {
    console.log('commit', commit);
}

export const iso8601 = (d: Date) => (new Date((d as any) - d.getTimezoneOffset() * 60 * 1000)).toISOString();

const loggedOutEndpoints = ['/login', '/reset', '/register', '/createAccountConsultant'];

export const forceHomeHref = () => {
    let loc = (location.href).split('#')[1] || '/';
    loc = loc.split('?')[0];
    if (location.href.includes('/checklist.docx')) {
        return false;
    }
    if (loc === '/registerConsultantAdmin') {
        return false;
    }
    if (loc.startsWith('/createAccountConsultantAdmin')) {
        return false;
    }
    return (loc === '/') || loggedOutEndpoints.some(prefix => loc.startsWith(prefix));
};

export const forceLoginHref = () => {
    let loc = (location.href).split('#')[1] || '/';
    loc = loc.split('?')[0];
    if (loc === '/' || loc === '/proposal/new') {
        return true;
    }
    if (['/kycAdmin'].some(prefix => loc.startsWith(prefix))) {
        return true;
    }
    if (['/createAccountConsultant', '/kyc', '/proposal3', '/proposal-profile'].some(prefix => loc.startsWith(prefix))) {
        return false;
    }
    return !forceHomeHref();
};

export const vals = (m: object) => Object.keys(m).map(k => m[k]);

export const timeout = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export function keyBy<A, B>(f: (x: A) => B, ss: A[]) {
    const result = new Map<B, A>();
    for (const s of ss) {
        result.set(f(s), s);
    }
    return result;
}

export const prMap = (m: Map<any, any>) => {
    const result = {};
    m.forEach((v: any, k: any) => result[k] = v);
    return JSON.stringify(result);
};

export const objToMap = (m: object) => {
    const result = new Map<any, any>();
    for (const k in m) {
        if (m.hasOwnProperty(k)) {
            result.set(k, m[k]);
        }
    }
    return result;
};

export const dissoc = (m: object, ... keys: string[]) => {
    const result = {...m};
    for (const k of keys) {
        delete result[k];
    }
    return result;
};

export const selectKeys = (m: object, ks: string[]) => {
    const result = {};
    for (const k of ks) {
        const v = m[k];
        if (v || v === false || v === '') {
            result[k] = v;
        }
    }
    return result;
};

export const getIn = (m: object, ks: (number | string)[]) => {
    for (const k of ks) {
        if (m instanceof Map) {
            m = m.get(k);
        } else if (m[k] && typeof m[k] === 'object') {
            m = m[k];
        } else {
            return m[k];
        }
    }
    return m;
};

export function takeLast<A>(i: number, s: A[]) {
    return i > s.length ? s : s.slice(s.length - i);
}

export function groupBy<A, B>(f: (x: A) => B, s: A[]): Map<B, A[]> {
    const result = new Map<B, A[]>();
    for (const x of s) {
        const k = f(x);
        const v = result.get(k);
        if (v) {
            v.push(x);
        } else {
            result.set(k, [x]);
        }
    }
    return result;
}

export function groupByObj<A>(f: (x: A) => string, s: A[], result?: object): any {
    result = result || {};
    for (const x of s) {
        const k = f(x);
        if (k in result) {
            result[k].push(x);
        } else {
            result[k] = [x];
        }
    }
    return result;
}

export const replaceAll = (s: string, a: string, b: string): string => {
    const t = s.replace(a, b);
    return s === t ? s : replaceAll(t, a, b);
};

export const removeChars = (s: string, toRemove: string[]) => toRemove.reduce((t, u) => replaceAll(t, u, ''), s);

export function repeat<A>(n: number, a: A): A[] {
    const result = [];
    for (let i = 0; i < n; i++) {
        result.push(a);
    }
    return result;
}

export function range(n: number) {
    const result = [];
    for (let i = 0; i < n; i++) {
        result.push(i);
    }
    return result;
}

export function removeI<A>(i: number, as: A[]): A[] {
    return as.filter((a, j) => i !== j);
}

export function assoc<A extends object>(m: A, k: string | number, v: any): A {
    if (m instanceof Array) {
        const m2 = Array.from(m);
        m2[k] = v;
        return m2 as A;
    } else if (m instanceof Map) {
        const m2 = new Map(m);
        m2.set(k, v);
        return m2 as A;
    } else {
        return {...(m as object), [k]: v} as A;
    }
}

export function assocIn<A extends object>(m: A, ks: (string | number)[], v: any): A {
    const k = ks[0];
    if (ks.length > 1) {
        if (m instanceof Array) {
            const m2 = Array.from(m);
            m2[k] = assocIn(m[k] || {}, ks.slice(1), v);
            return m2 as A;
        } else {
            return {...(m as object), [k]: assocIn(m[k] || {}, ks.slice(1), v)} as A;
        }
    } else {
        return assoc(m, k, v);
    }
}

export function update<A extends object>(m: A, k: string | number, f: (x: any) => any): A {
    if (m instanceof Array) {
        const m2 = Array.from(m);
        m2[k] = f(m[k]);
        return m2 as A;
    } else {
        return {...(m as object), [k]: f(m[k])} as A;
    }
}

export function updateIn<A extends object>(m: A, ks: (string | number)[], f: (x: any) => any): A {
    const k = ks[0];
    if (ks.length > 1) {
        if (m instanceof Array) {
            const m2 = Array.from(m);
            m2[k] = updateIn(m[k] || {}, ks.slice(1), f);
            return m2 as A;
        } else {
            return {...(m as object), [k]: updateIn(m[k] || {}, ks.slice(1), f)} as A;
        }
    } else {
        return update(m, k, f);
    }
}

export const inc = (x: number) => x + 1;
export const dec = (x: number) => x - 1;

export function distinct<A>(s: A[]): A[] {
    const items = new Set<A>();
    const result = [] as A[];
    for (const item of s) {
        if (!items.has(item)) {
            items.add(item);
            result.push(item);
        }
    }
    return result;
}

export function union<A>(s1: Set<A>, s2: Set<A>) {
    const s3 = new Set<A>();
    s1.forEach((a: A) => {
        if (s2.has(a)) {
            s3.add(a);
        }
    });
    return s3;
}

export function uniqueBy<A, B>(f: (x: A) => B, s: A[]): A[] {
    const done = new Set<B>();
    const result = [] as A[];
    for (const a of s) {
        const b = f(a);
        if (!done.has(b)) {
            done.add(b);
            result.push(a);
        }
    }
    return result;
}

export const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatDate = (d: Date) => `${d.getDate()} ${shortMonths[d.getMonth()]} ${d.getFullYear()}`;

export function toggle<A>(s: Set<A>, k: A): Set<A> {
    if (s.has(k)) {
        s.delete(k);
    } else {
        s.add(k);
    }
    return s;
}

export const not = (x: any) => !x;
export const notEmpty = (x: any) => x.length ? x : null;
export const isNotEmpty = (x: any) => x.length ? x.length > 0 : x.size ? x.size > 0 : false;
export const isEmpty = (x: any) => !isNotEmpty(x);

export const trimLines = (s: string) => s.split('\n').map(t => t.trim()).join('\n');

// export interface EmailRecipient {
//     name?: string;
//     email: string;
// }

// const emailStr = ({name, email}: EmailRecipient) => name ? `${encodeURIComponent(name)}<${email}>` : email;
// const toStr = (emails: EmailRecipient[]) => emails.map(emailStr).join(';');
// export const mailto365 = (to: EmailRecipient[], subject: string, body: string) => `https://outlook.office.com/?path=/mail/action/compose&to=${toStr(to)}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
// export const mailto = (to: EmailRecipient[], subject: string, body: string, cc?: EmailRecipient[]) => `mailto:${toStr(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}${cc ? `&cc=${toStr(cc)}` : ''}`;

export function last<A>(s: A[]) {
    return s.length > 0 ? s[s.length - 1] : null;
}

export function moveDown<A>(ss: A[], i: number) {
    return ss.map((s: A, j: number) => j === i ? ss[i + 1] : j === i + 1 ? ss[i] : s);
}

export const capitalize = (s: string) => s.substring(0, 1).toUpperCase() + s.substring(1);

export const adminName = (email: string) => {
    const [firstName, lastName] = email.split('@')[0].split('.');
    return lastName ? `${capitalize(firstName)} ${capitalize(lastName)}` :
        firstName === 'hq' ? 'Korum Admin' : capitalize(firstName);
};

export const adminFirstName = (email: string) => {
    const [firstName] = email.split('@')[0].split('.');
    return firstName === 'hq' ? 'Korum Admin' : capitalize(firstName);
};

export function splitAt<A>(i: number, s: A[]) {
    return [s.slice(0, i), s.slice(i)];
}

export function splitAts<A>(is: number[], s: A[]): A[][] {
    const [a, b] = splitAt(is[0], s);
    if (is.length === 1) {
        return [a];
    } else {
        return [a, ...splitAts(is.slice(1), b)];
    }
}

export const invertObj = (o: object) => {
    const out = {};
    for (const k in o) {
        if (o.hasOwnProperty(k)) {
            out[o[k]] = k;
        }
    }
    return out;
};

export function zipObj<A>(f1: (x: A) => string, f2: (x: A) => any, as: A[]) {
    const result = {};
    for (const a of as) {
        result[f1(a)] = f2(a);
    }
    return result;
}

export function splitWith<A>(f: (x: A) => any, as: A[]) {
    const trues = [], falses = [];
    for (const a of as) {
        if (f(a)) {
            trues.push(a);
        } else {
            falses.push(a);
        }
    }
    return [trues, falses];
}

export function dropLast<A>(i: number, s: A[]) {
    const j = Math.max(0, s.length - i);
    return s.slice(0, j);
}

export const paraSplit = (s: string) => s.trim().split(/\n\n|●/);
(global as any).paraSplit = paraSplit;

export function some<A, B>(f: (a: A, i: number) => B, as: A[]): B | undefined {
    for (let i = 0; i < as.length; i++) {
        const b = f(as[i], i);
        if (b !== null && b !== undefined) {
            return b;
        }
    }
    return undefined;
}

export const stringifyMap = (m: Map<any, any>) => JSON.stringify(
    Array.from(m).reduce(
        (obj, [key, value]) => {
            obj[key] = value;
            return obj;
        },
        {}));

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const toBeImplemented = (e?: any) => {
    if (e) {
        e.preventDefault();
    }
    alert('To be implemented.');
};

export const promptTrim = (s: string) => {
    const response = prompt(s);
    return response ? response.trim() : null;
};

export const title = (t: string, body: any) => t ? <DocumentTitle title={`KorumLegal Axceller - ${t}`}>{body}</DocumentTitle> : body;
export const date = (s: string) => new Date(s);
export const dateOption = (s: string | undefined) => s ? new Date(s) : undefined;
export const renderDate = (d: Date | undefined) => d ? d.toISOString().split('T')[0] : '';

export const preventDefault = (f?: () => void) => (e: any) => {
    e.preventDefault();
    if (f) {
        f();
    }
};

export const into = (o: object, kvs: any[][]) => {
    kvs.forEach(kv => o[kv[0]] = kv[1]);
    return o;
};

export const valMap = (f: (x: any) => any, o: object) => {
    const out = {};
    for (let k in o) {
        if (o.hasOwnProperty(k)) {
            out[k] = f(o[k]);
        }
    }
    return out;
};

export const queryString = () => qs.parse(location.hash.split('?')[1]);
export const rutvi = 'rutvi.thakkar@korumlegal.com';
export const amrita = 'amrita.hardikar@korumlegal.com';
export const support = 'hq@korumlegal.com';
export const sylvie = 'sylvie.healy@korumlegal.com';
export const accounts = 'accounts@korumlegal.com';

export const ellipsis = (s: string | undefined, i: number) => s ? s.length <= i ? s : s.substring(0, i - 3) + '...' : '';

export const debounceEvent = (func: (x: any) => void, delay: number) => {
    let inDebounce: any;
    return function(e: any) {
        const v = e.currentTarget.value;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func(v), delay);
    };
};

const debounces = {};
export const debounceEvent2 = (debounceKey: string, f1: (x: any) => void, f2: (x: any) => void, delay: number) => (
    (e: any) => {
        const v = e.currentTarget.value;
        clearTimeout(debounces[debounceKey]);
        f1(v);
        debounces[debounceKey] = setTimeout(() => f2(v), delay);
    }
);

export const clearParams = () => location.href.split('?')[0];

export const wordList = (words: string[]) => (
    words.length === 0 ? undefined :
    words.length === 1 ? words[0] :
    `${words.slice(0, words.length - 1).join(', ')} and ${last(words)}`
);


// WEBPACK FOOTER //
// ./src/util.tsx